import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class GraphQlService {
    constructor(private http: HttpClient) {}

    post({
        query,
        variables = {},
        role = 'platon/ROLE_ADMIN',
        roles = [],
    }: {
        query: string;
        variables: { [key: string]: any };
        role?: string;
        roles?: string[];
    }) {
        const headers =
            roles.length === 0
                ? new HttpHeaders().set('X-Hasura-Role', role)
                : roles.reduce(
                      (headers, role) => headers.set('X-Hasura-Role', role),
                      new HttpHeaders()
                  );
        return this.http
            .post<{ data: any }>(
                '/v1/graphql',
                { query, variables },
                {
                    headers,
                }
            )
            .pipe(map((response) => response.data));
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/graphql/graphql.service.ts